(function(NS, undefined) {
  
  function openCartDrawer() {
    document.querySelector(".cart-drawer").classList.add("cart-drawer--active");
  }

  function closeCartDrawer() {
    const drawer = document.querySelector(".cart-drawer");
    drawer.classList.add("cart-drawer--closing");
    drawer.classList.remove("cart-drawer--active");
    menuTimer = window.setTimeout(function() {
      drawer.classList.remove('cart-drawer--closing');
    }, 600);
  }

  function updateCartItemCounts(count) {
    document.querySelectorAll(".js--cart-counter").forEach((el) => {
      el.classList.toggle("empty", count === 0);
      // el.textContent = "("  + count + ")";
    });
  }

  async function updateCartDrawer() {
    const res = await fetch("/?section_id=cart-drawer");
    const text = await res.text();
    const html = document.createElement("div");
    html.innerHTML = text;

    const newBox = html.querySelector(".cart-drawer").innerHTML;

    document.querySelector(".cart-drawer").innerHTML = newBox;

    addCartDrawerListeners();
  }
  NS.updateCartDrawer = updateCartDrawer;

  function addCartDrawerListeners() {
    // Update quantities
    document
      .querySelectorAll(".cart-drawer-quantity-selector button")
      .forEach((button) => {
        button.addEventListener("click", async () => {
          // Get line item key
          const rootItem =
            button.closest(".cart-drawer-item");
          const key = rootItem.getAttribute("data-line-item-key");

          // Get new quantity
          const currentQuantity = Number(
            button.parentElement.querySelector("input").value
          );
          const isUp = button.classList.contains(
            "cart-drawer-quantity-selector-plus"
          );
          const newQuantity = isUp ? currentQuantity + 1 : currentQuantity - 1;

          // Ajax update\
          const res = await fetch("/cart/update.js", {
            method: "post",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates: { [key]: newQuantity } }),
          });
          const cart = await res.json();

          updateCartItemCounts(cart.item_count);

          // Update cart
          updateCartDrawer();
        });
      });

    document.querySelectorAll(".cart-drawer-item-remove").forEach((button) => {
      button.addEventListener("click", async () => {
        // Get line item key
        const rootItem = button.closest(".cart-drawer-item");
        const key = rootItem.getAttribute("data-line-item-key");

        // Ajax update\
        const res = await fetch("/cart/update.js", {
          method: "post",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
          body: JSON.stringify({ updates: { [key]: 0 } }),
        });
        const cart = await res.json();

        updateCartItemCounts(cart.item_count);

        // Update cart
        updateCartDrawer();
      });
    });

    document.querySelector(".cart-drawer-box").addEventListener("click", (e) => {
      e.stopPropagation();
    });

    document
      .querySelectorAll(".cart-drawer-close, .cart-drawer")
      .forEach((el) => {
        el.addEventListener("click", () => {
          console.log("closing drawer");
          closeCartDrawer();
        });
      });
  }

  addCartDrawerListeners();

  document.querySelectorAll('form[action="/cart/add"]').forEach((form) => {
    form.addEventListener("submit", async (e) => {
      e.preventDefault();

      // Show spinner on 'add to cart' button
      let addToCartButton = document.querySelector("#js--addtocart");
      if (addToCartButton) {
        addToCartButton.classList.add("active");
      }

      // Submit form with ajax
      await fetch("/cart/add", {
        method: "post",
        body: new FormData(form),
      });

      // Get cart count
      const res = await fetch("/cart.js");
      let cart = await res.json();
      updateCartItemCounts(cart.item_count);

      // Special case for angel product:
      // Remove multiples of identical angel products (avoid accidental double-add by customer)
      for (const prop in cart.items) {
        const item = cart.items[prop];
        if (item.handle = "give-an-angel" && item.quantity > 1) {
          // Ajax update\
          const res = await fetch("/cart/update.js", {
            method: "post",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates: { [item.key]: 1 } }),
          });
          cart = await res.json(); // re-fetch cart

          updateCartItemCounts(cart.item_count);
        }
      }

      // Update cart
      await updateCartDrawer();

      // Open cart drawer
      window.setTimeout(() => {
        openCartDrawer();
      }, 100);

      // Hide spinner
      if (addToCartButton) {
        addToCartButton.classList.remove("active");
      }
    });
  });

  document.querySelectorAll('a[href="/cart"]').forEach((a) => {
    a.addEventListener("click", (e) => {
      e.preventDefault();
      openCartDrawer();
    });
  });

}(window.fnapp = window.fnapp || {}));

// Called by Dr Free Gift app instead when gift product (i.e. donation) is added/removed from cart
window.refreshCart = function() {
  window.fnapp.updateCartDrawer();
}